import { render, staticRenderFns } from "./DialogVolumesBarChart.vue?vue&type=template&id=3f0b6aec&"
import script from "./DialogVolumesBarChart.vue?vue&type=script&lang=ts&"
export * from "./DialogVolumesBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./DialogVolumesBarChart.vue?vue&type=style&index=0&id=3f0b6aec&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports